import { useConfig as useSharedConfig } from '@shared/config/use-config';
import { links } from './links';
export const defaultFundListConfig = {
    links,
    featureToggles: {
        showFundQueryPresets: true,
        showFundGuideButton: false,
    },
    fundListOptions: undefined,
};
export const useConfig = () => useSharedConfig();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnVuZC1saXN0LWNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9hcHBzL2Z1bmQtbGlzdC9jb25maWcvZnVuZC1saXN0LWNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxJQUFJLGVBQWUsRUFBRSxNQUFNLDJCQUEyQixDQUFDO0FBSXpFLE9BQU8sRUFBRSxLQUFLLEVBQWMsTUFBTSxTQUFTLENBQUM7QUFhNUMsTUFBTSxDQUFDLE1BQU0scUJBQXFCLEdBQW1CO0lBQ2pELEtBQUs7SUFDTCxjQUFjLEVBQUU7UUFDWixvQkFBb0IsRUFBRSxJQUFJO1FBQzFCLG1CQUFtQixFQUFFLEtBQUs7S0FDN0I7SUFDRCxlQUFlLEVBQUUsU0FBUztDQUM3QixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLEdBQW1CLEVBQUUsQ0FBQyxlQUFlLEVBQWtCLENBQUMifQ==